"use strict";
/*
 * Created on 03 22 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author Jaroslav Sevcik
 */


var PriceStickersDashboardReportDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(PriceStickersDashboardReportDTOConverter, _DataObjectConverter_);

  function PriceStickersDashboardReportDTOConverter() {
    _classCallCheck(this, PriceStickersDashboardReportDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(PriceStickersDashboardReportDTOConverter).apply(this, arguments));
  }

  return PriceStickersDashboardReportDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.PriceStickersDashboardReportDTOConverter = PriceStickersDashboardReportDTOConverter;